export function NoPairedDeviceSvg(props: React.SVGProps<SVGSVGElement>): React.ReactNode {
  return (
    <svg
      fill="none"
      height="118"
      viewBox="0 0 424 118"
      width="424"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M231.424 2.50435C231.424 2.48546 231.424 2.48546 231.424 2.50435L230.668 2.05105C230.517 1.9755 230.309 1.9755 230.102 2.10771L173.477 34.7831C173.024 35.0475 172.665 35.6708 172.665 36.1996V89.8212C172.665 90.0856 172.759 90.2745 172.91 90.3501L173.628 90.7656C173.779 90.86 173.987 90.8411 174.214 90.7089L230.819 58.0147C231.273 57.7503 231.632 57.127 231.632 56.5981V2.97653C231.632 2.76877 231.556 2.5799 231.424 2.50435Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M174.214 35.2189L230.819 2.52469C231.273 2.26026 231.632 2.46802 231.632 2.99687V56.6185C231.632 57.1473 231.273 57.7706 230.819 58.035L174.214 90.7293C173.76 90.9937 173.401 90.7859 173.401 90.2571V36.6355C173.401 36.1066 173.76 35.4834 174.214 35.2189Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M176.178 37.9178L228.874 7.49005V52.4612L176.178 82.8889V37.9178Z"
        fill="white"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M275.092 80.2648L232.859 55.8811C232.463 55.6544 231.839 55.6544 231.443 55.8811L174.535 88.7453C174.346 88.8586 174.232 89.0097 174.232 89.1608V91.0496C174.232 91.2007 174.327 91.3518 174.535 91.4651L216.767 115.83C217.164 116.057 217.787 116.057 218.184 115.83L275.092 82.9657C275.281 82.8524 275.375 82.7013 275.394 82.5691V80.6804C275.394 80.5293 275.299 80.3782 275.092 80.2648Z"
        fill="#FFD6BC"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M232.859 55.8811L275.092 80.2648C275.488 80.4915 275.488 80.8503 275.092 81.077L218.184 113.941C217.787 114.168 217.164 114.168 216.767 113.941L174.535 89.5575C174.138 89.3308 174.138 88.972 174.535 88.7453L231.443 55.8811C231.839 55.6544 232.463 55.6544 232.859 55.8811Z"
        fill="white"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M190.419 88.4446L190.929 88.7468L193.819 87.0658V86.4803L194.329 86.7825L197.219 85.1015V84.516L197.728 84.8182L200.618 83.1372V82.5517L201.128 82.8539L204.018 81.1729V80.5874L204.528 80.8896L207.418 79.2086V78.6231L207.928 78.9253L210.818 77.2632V76.6588L211.327 76.961L214.217 75.2989V74.6945L214.727 74.9967L217.617 73.3346V72.7302L218.127 73.0324L221.036 71.3703L221.017 70.7848L221.546 71.0681L224.435 69.406L224.417 68.8205L224.945 69.1038L227.835 67.4417L227.816 66.8562L228.345 67.1395L231.235 65.4774L231.216 64.8919L231.745 65.1752L234.635 63.5131L234.616 62.7953L231.726 64.4575L229.856 63.3998V64.1175L231.103 64.8163L228.326 66.4217L226.456 65.364V66.0818L227.703 66.7806L224.926 68.386L223.057 67.3283V68.0461L224.303 68.7449L221.527 70.3503L219.657 69.2926V69.9915L220.903 70.7092L218.127 72.3146L216.257 71.2569V71.9558L217.504 72.6735L214.727 74.2789L212.838 73.2024L212.857 73.9201L214.104 74.6378L211.327 76.2432L209.458 75.1667V75.8844L210.704 76.6021L207.928 78.2075L206.039 77.131L206.058 77.8487L207.304 78.5664L204.528 80.1718L202.639 79.0953L202.658 79.813L203.905 80.5307L201.128 82.1361L199.239 81.0596L199.258 81.7773L200.505 82.495L197.728 84.1004L195.84 83.0239L195.859 83.7416L197.105 84.4593L194.329 86.0647L192.44 84.9882L192.459 85.7059L193.705 86.4236L190.929 88.029L189.04 86.9524L189.059 87.6702L190.306 88.3879L187.529 89.9933L185.641 88.9168L185.659 89.6345L187.529 90.7111L190.419 89.0301V88.4446Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M230.328 66.0063V66.724L233.596 68.575L238.526 65.723L238.507 65.0052L233.577 67.8573L230.328 66.0063Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M230.347 69.7264L227.08 67.8754L227.099 68.5931L230.347 70.4441L232.897 68.9709V68.2531L230.347 69.7264Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M223.85 70.4657L227.099 72.3167L229.648 70.8435V70.1258L227.099 71.599L223.85 69.748V70.4657Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M220.601 72.3326L223.85 74.1836L226.419 72.7104L226.4 72.0115L223.85 73.4848L220.601 71.6149V72.3326Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M217.372 74.2038L220.62 76.0737L223.17 74.6004L223.151 73.8827L220.601 75.3559L217.353 73.505L217.372 74.2038Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M214.123 76.0924L217.371 77.9433L219.921 76.4701V75.7524L217.371 77.2256L214.104 75.3746L214.123 76.0924Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M210.874 77.9622L214.123 79.8132L216.673 78.34V77.6222L214.123 79.0955L210.874 77.2445V77.9622Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M207.625 79.832L210.893 81.683L213.443 80.2098L213.424 79.4921L210.874 80.9653L207.625 79.1143V79.832Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M204.396 81.7017L207.644 83.5527L210.194 82.0795L210.175 81.3618L207.626 82.835L204.377 80.984L204.396 81.7017Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M201.147 83.5714L204.396 85.4224L206.946 83.9491V83.2503L204.396 84.7046L201.128 82.8537L201.147 83.5714Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M197.898 85.4412L201.147 87.2922L203.697 85.8379V85.1201L201.147 86.5934L197.898 84.7235V85.4412Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M194.65 87.3095L197.917 89.1793L200.467 87.7061L200.448 86.9884L197.899 88.4616L194.65 86.6106V87.3095Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M191.42 89.2012L194.669 91.0521L197.218 89.5789L197.2 88.8612L194.65 90.3344L191.401 88.4834L191.42 89.2012Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M193.97 90.7279L191.42 92.2011L188.171 90.3501V91.0679L191.42 92.9188L193.97 91.4456V90.7279Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M235.862 67.9896L239.111 69.8595L242.511 67.8952L242.492 67.1775L239.092 69.1418L235.843 67.2908L235.862 67.9896Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M238.431 70.2384L238.412 69.5396L235.862 70.9939L232.614 69.1429V69.8607L235.881 71.7116L238.431 70.2384Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M235.201 72.1057L235.182 71.3879L232.633 72.8612L229.384 71.0102V71.7279L232.651 73.5789L235.201 72.1057Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M231.971 73.9781L231.953 73.2604L229.403 74.7336L226.154 72.8827V73.6004L229.403 75.4514L231.971 73.9781Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M228.723 75.845V75.1273L226.173 76.6005L222.924 74.7495V75.4673L226.173 77.3182L228.723 75.845Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M225.493 77.7192V77.0014L222.943 78.4747L219.695 76.6048V77.3225L222.943 79.1735L225.493 77.7192Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M222.263 79.5671V78.8493L219.713 80.3226L216.465 78.4716V79.1893L219.713 81.0403L222.263 79.5671Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M219.034 81.4369V80.7192L216.484 82.1924L213.216 80.3415L213.235 81.0592L216.484 82.9102L219.034 81.4369Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M215.804 83.3066V82.5889L213.254 84.0621L209.986 82.2111L210.005 82.9288L213.254 84.7798L215.804 83.3066Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M212.574 85.1763V84.4585L210.024 85.9318L206.757 84.0808L206.776 84.7796L210.024 86.6495L212.574 85.1763Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M209.344 87.0288L209.325 86.3299L206.776 87.8031L203.527 85.9333L203.546 86.651L206.794 88.502L209.344 87.0288Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M200.297 87.7999L200.316 88.5176L203.565 90.3686L206.115 88.8953L206.096 88.1776L203.546 89.6508L200.297 87.7999Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M200.335 92.2415L202.885 90.7683L202.866 90.0505L200.316 91.5238L197.067 89.6728V90.3905L200.335 92.2415Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M199.636 91.9176L195.311 94.4108L192.043 92.5598L192.062 93.2775L195.311 95.1285L199.655 92.6354L199.636 91.9176Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M237.411 70.8388L237.43 71.5565L240.679 73.4075L246.402 70.1022L246.383 69.3844L240.66 72.6897L237.411 70.8388Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M239.98 73.8066V73.0889L237.43 74.5621L234.181 72.7111V73.4288L237.43 75.2798L239.98 73.8066Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M236.731 75.6764V74.9587L234.182 76.4319L230.933 74.581V75.2987L234.182 77.1497L236.731 75.6764Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M233.501 77.5461L233.483 76.8284L230.933 78.3016L227.684 76.4506V77.1683L230.952 79.0193L233.501 77.5461Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M230.253 79.4348V78.7171L227.684 80.1903L224.436 78.3205L224.454 79.0382L227.703 80.8892L230.253 79.4348Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M227.004 81.306V80.5883L224.454 82.0615L221.206 80.2105V80.9094L224.454 82.7792L227.004 81.306Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M223.774 83.1757L223.755 82.4579L221.206 83.9312L217.957 82.0802V82.7979L221.206 84.6489L223.774 83.1757Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M220.526 85.0455L220.507 84.3278L217.957 85.801L214.708 83.95L214.727 84.6678L217.976 86.5187L220.526 85.0455Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M217.277 86.9154V86.1977L214.727 87.6709L211.46 85.8199L211.479 86.5376L214.727 88.3886L217.277 86.9154Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M214.028 88.7823V88.0645L211.479 89.5378L208.23 87.6868V88.4045L211.479 90.2555L214.028 88.7823Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M210.799 90.6547L210.78 89.9559L208.23 91.4102L204.981 89.5592V90.277L208.249 92.1279L210.799 90.6547Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M205 94.0152L207.55 92.542L207.531 91.8243L204.981 93.2975L201.733 91.4465L201.751 92.1454L205 94.0152Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M204.301 93.6972L199.202 96.6437L195.934 94.7927L195.953 95.5104L199.202 97.3614L204.301 94.4149V93.6972Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M254.089 74.4873V73.7695L251.237 75.4127L249.745 74.5628V75.2805L250.595 75.7716L247.913 77.3204L246.779 76.6782L249.008 75.3939V74.6761L246.156 76.3193L244.739 75.5072L250.274 72.3152V71.5975L241.944 76.4138L238.695 74.5628V75.2805L241.321 76.7726L238.79 78.227L235.541 76.376V77.0937L238.167 78.5858L235.636 80.0402L232.387 78.1892V78.9069L235.012 80.399L232.482 81.8534L229.233 80.0024V80.7201L231.858 82.2122L229.327 83.6666L226.079 81.8156V82.5333L228.704 84.0254L226.173 85.4798L222.924 83.6288V84.3465L225.55 85.8386L223.019 87.293L219.77 85.442V86.1597L222.396 87.6518L219.865 89.1062L216.616 87.2552V87.9729L219.241 89.465L216.71 90.9194L213.462 89.0684V89.7861L216.087 91.2782L213.556 92.7326L210.308 90.8816V91.5993L212.933 93.0914L210.402 94.5458L207.153 92.6948V93.4125L209.779 94.9046L202.998 98.8143L199.749 96.9634V97.6811L202.998 99.5321L203.546 99.211V99.8532L206.795 101.704L209.344 100.231V99.5132L206.795 100.986L203.621 99.1732L206.946 97.2467V97.8889L210.194 99.7398L212.744 98.2666V97.5489L210.194 99.0221L207.021 97.2089L209.798 95.6035V94.9235L210.345 95.2446V95.9246L213.594 97.7755L216.144 96.3023V95.5846L213.594 97.0578L210.421 95.2446L212.952 93.7903V93.1103L213.556 93.4503L213.764 93.337V93.9791L217.013 95.8301L220.186 93.998V93.337L220.752 93.6581L236.618 84.4976V83.9121L237.128 84.2143L240.811 82.08V81.419L241.378 81.7401L243.927 80.2668V79.5491L241.378 81.0223L238.129 79.1714V79.8891L240.754 81.3812L237.128 83.4777L233.955 81.6645L234.994 81.0601V80.3802L235.598 80.7201L238.148 79.2469V78.567L238.752 78.9069L241.302 77.4337V76.7538L241.906 77.0937L244.645 75.5261V76.1682L246.137 77.0182L246.42 76.8482V77.1693L247.27 77.6604L244.588 79.2091L243.096 78.3592V79.0769L244.588 79.9269L247.44 78.2836V77.7737L247.894 78.0381L250.746 76.3949V75.8849L251.199 76.1494L254.089 74.4873ZM217.088 95.1313L213.915 93.3181L216.182 92.0149V91.3349L216.786 91.6749L217.579 91.2216V91.8637L220.205 93.3559L217.088 95.1313ZM233.974 82.3822L236.599 83.8743L220.847 92.9781L217.674 91.1649L219.355 90.2017V89.5217L219.959 89.8617L222.509 88.3885V87.7085L223.113 88.0485L225.663 86.5753V85.8953L226.268 86.2353L228.817 84.7621V84.0821L229.422 84.4221L231.972 82.9489V82.2689L232.576 82.6089L234.03 81.7778L233.974 82.3822Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M232.746 61.7168L234.616 62.7934L231.726 64.4555L229.856 63.3978L232.746 61.7168Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M229.346 63.6822L231.216 64.7588L228.326 66.4209L226.457 65.3632L229.346 63.6822Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M225.946 65.6451L227.816 66.7217L224.926 68.3838L223.057 67.3261L225.946 65.6451Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M222.547 67.6077L224.417 68.6843L221.527 70.3464L219.657 69.2887L222.547 67.6077Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M219.147 69.5732L221.017 70.6498L218.127 72.3119L216.257 71.2542L219.147 69.5732Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M215.747 71.5394L217.617 72.616L214.727 74.2781L212.839 73.2015L215.747 71.5394Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M212.328 73.5048L214.217 74.5814L211.327 76.2435L209.458 75.1669L212.328 73.5048Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M208.948 75.4678L210.818 76.5444L207.928 78.2065L206.039 77.1299L208.948 75.4678Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M205.529 77.4305L207.418 78.5071L204.528 80.1692L202.639 79.0926L205.529 77.4305Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M202.129 79.3966L204.018 80.4732L201.128 82.1353L199.24 81.0587L202.129 79.3966Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M198.73 81.3588L200.618 82.4354L197.729 84.0975L195.84 83.0209L198.73 81.3588Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M195.33 83.3248L197.219 84.3825L194.329 86.0635L192.44 84.9869L195.33 83.3248Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M191.93 85.2903L193.819 86.348L190.929 88.029L189.04 86.9524L191.93 85.2903Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M188.53 87.2532L190.419 88.3109L187.529 89.9919L185.641 88.9153L188.53 87.2532Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M235.258 63.153L238.507 65.0039L233.577 67.8559L230.329 66.005L235.258 63.153Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M229.629 66.4009L232.897 68.2519L230.347 69.7251L227.08 67.8742L229.629 66.4009Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M226.4 68.2735L229.648 70.1244L227.099 71.5977L223.85 69.7467L226.4 68.2735Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M223.151 70.1401L226.4 72.0099L223.85 73.4832L220.602 71.6133L223.151 70.1401Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M219.902 72.0307L223.151 73.8817L220.601 75.3549L217.353 73.5039L219.902 72.0307Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M216.654 73.9008L219.921 75.7517L217.372 77.225L214.104 75.374L216.654 73.9008Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M213.424 75.7701L216.673 77.621L214.123 79.0942L210.874 77.2433L213.424 75.7701Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M210.175 77.6401L213.424 79.491L210.874 80.9643L207.625 79.1133L210.175 77.6401Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M206.927 79.5102L210.175 81.3612L207.626 82.8344L204.377 80.9834L206.927 79.5102Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M203.678 81.3824L206.946 83.2523L204.396 84.7066L201.128 82.8557L203.678 81.3824Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M200.448 83.2699L203.697 85.1209L201.147 86.5941L197.899 84.7243L200.448 83.2699Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M197.2 85.1365L200.449 86.9875L197.899 88.4607L194.65 86.6098L197.2 85.1365Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M193.951 87.0091L197.2 88.86L194.65 90.3333L191.401 88.4823L193.951 87.0091Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M190.721 88.8759L193.97 90.7268L191.42 92.2001L188.172 90.3491L190.721 88.8759Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M235.164 67.6686L238.412 69.5385L235.863 70.9928L232.614 69.1418L235.164 67.6686Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M231.934 69.5357L235.183 71.3866L232.633 72.8599L229.384 71.0089L231.934 69.5357Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M228.704 71.4055L231.953 73.2565L229.403 74.7297L226.154 72.8787L228.704 71.4055Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M225.474 73.2755L228.723 75.1265L226.173 76.5997L222.924 74.7488L225.474 73.2755Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M222.245 75.148L225.493 76.999L222.943 78.4722L219.695 76.6023L222.245 75.148Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M219.015 76.9976L222.263 78.8486L219.714 80.3218L216.465 78.4708L219.015 76.9976Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M215.785 78.8667L219.034 80.7177L216.484 82.1909L213.216 80.34L215.785 78.8667Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M212.536 80.7368L215.804 82.5877L213.254 84.061L209.987 82.21L212.536 80.7368Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M209.307 82.6068L212.574 84.4578L210.024 85.931L206.757 84.08L209.307 82.6068Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M206.077 84.4564L209.325 86.3263L206.776 87.7995L203.527 85.9296L206.077 84.4564Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M202.847 86.3287L206.096 88.1796L203.546 89.6529L200.297 87.8019L202.847 86.3287Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M199.617 88.1987L202.866 90.0497L200.316 91.5229L197.067 89.6719L199.617 88.1987Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M196.388 90.0678L199.636 91.9188L195.311 94.4119L192.044 92.561L196.388 90.0678Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M239.243 65.3251L235.844 67.2894L239.734 69.4993L237.411 70.8403L240.66 72.6913L246.383 69.3859L239.243 65.3251Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M236.731 71.2339L239.98 73.0849L237.43 74.5581L234.181 72.7071L236.731 71.2339Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M233.483 73.1063L236.731 74.9573L234.181 76.4305L230.933 74.5795L233.483 73.1063Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M230.234 74.9762L233.483 76.8271L230.933 78.3004L227.684 76.4494L230.234 74.9762Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M226.985 76.8636L230.253 78.7146L227.684 80.1878L224.436 78.318L226.985 76.8636Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M223.756 78.7361L227.004 80.5871L224.455 82.0603L221.206 80.2093L223.756 78.7361Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M220.507 80.606L223.756 82.4569L221.206 83.9302L217.957 82.0792L220.507 80.606Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M217.258 82.4758L220.507 84.3268L217.957 85.8L214.708 83.949L217.258 82.4758Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M214.01 84.343L217.277 86.194L214.727 87.6672L211.46 85.8163L214.01 84.343Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M210.78 86.2123L214.029 88.0633L211.479 89.5365L208.23 87.6856L210.78 86.2123Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M207.531 88.0847L210.78 89.9546L208.23 91.4089L204.981 89.5579L207.531 88.0847Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M204.283 89.9719L207.531 91.8229L204.981 93.2961L201.733 91.4451L204.283 89.9719Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M201.034 91.8417L204.301 93.6927L199.202 96.6392L195.934 94.7882L201.034 91.8417Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M247.025 69.7451L250.274 71.6149L241.944 76.4123L238.696 74.5614L247.025 69.7451Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M238.091 74.9008L241.34 76.7517L238.79 78.225L235.541 76.374L238.091 74.9008Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M234.956 76.7329L238.204 78.5839L235.655 80.0571L232.406 78.1873L234.956 76.7329Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M231.802 78.5445L235.05 80.3955L232.501 81.8687L229.252 80.0178L231.802 78.5445Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M228.647 80.3621L231.915 82.2131L229.365 83.6863L226.098 81.8353L228.647 80.3621Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M225.512 82.1705L228.761 84.0214L226.211 85.4947L222.962 83.6437L225.512 82.1705Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M222.358 83.9879L225.625 85.8389L223.057 87.3121L219.808 85.4611L222.358 83.9879Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M219.222 85.7965L222.471 87.6664L219.921 89.1396L216.673 87.2697L219.222 85.7965Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M216.069 87.6311L219.317 89.4821L216.767 90.9553L213.519 89.1043L216.069 87.6311Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M212.933 89.4427L216.182 91.2937L213.632 92.7669L210.383 90.9159L212.933 89.4427Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M209.779 91.2577L213.027 93.1087L210.478 94.5819L207.229 92.7309L209.779 91.2577Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M206.625 93.0693L209.892 94.9203L203.093 98.8489L199.825 96.9979L206.625 93.0693Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M247.535 73.8251L249.027 74.6751L246.156 76.3183L244.683 75.4683L247.535 73.8251Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M252.597 72.9379L254.089 73.769L251.237 75.4311L249.745 74.5811L252.597 72.9379Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M249.31 74.8224L250.784 75.6724L247.932 77.3156L246.458 76.4845L249.31 74.8224Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M246.005 76.7329L247.497 77.5829L244.645 79.2261L243.153 78.3761L246.005 76.7329Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M240.754 77.7328L244.022 79.5838L241.472 81.057L238.205 79.2061L240.754 77.7328Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M237.638 79.5273L240.905 81.3972L237.203 83.5126L233.955 81.6616L237.638 79.5273Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M233.445 81.9642L236.694 83.8152L220.828 92.9756L217.579 91.1247L233.445 81.9642Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M217.013 91.4467L220.261 93.2977L217.088 95.1298L213.84 93.2788L217.013 91.4467Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M212.99 93.7695L216.238 95.6204L213.688 97.0937L210.44 95.2427L212.99 93.7695Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M209.59 95.7325L212.839 97.5835L210.289 99.0567L207.04 97.2057L209.59 95.7325Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M206.19 97.6984L209.439 99.5494L206.889 101.023L203.64 99.1716L206.19 97.6984Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.2"
      />
      <path
        d="M242.568 84.6469L253.069 90.7098C253.352 90.8797 253.352 91.1442 253.069 91.3142L236.618 100.815C236.335 100.985 235.863 100.985 235.579 100.815L225.078 94.7517C224.794 94.5817 224.794 94.3173 225.078 94.1473L241.529 84.6469C241.812 84.4769 242.284 84.4769 242.568 84.6469Z"
        stroke="#1D1D1B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
      <path
        d="M159.732 79.4162C159.534 79.2896 159.372 79.118 159.261 78.9108C159.15 78.7037 159.095 78.4716 159.099 78.2368V28.1191C159.097 27.4749 159.255 26.8402 159.559 26.2723C159.864 25.7043 160.304 25.2209 160.842 24.8656L180.695 13.7162C181.344 13.3488 181.259 13.5543 182.182 14.2131C183.104 14.8718 182.984 15.7005 182.984 16.1963L183 65.3054C183.003 65.961 182.842 66.6068 182.531 67.1843C182.221 67.7618 181.771 68.2526 181.222 68.6121L161.959 79.708C161.679 79.8392 161.372 79.8998 161.064 79.8844C160.478 79.8844 160.091 79.6461 159.732 79.4162Z"
        fill="white"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M158.113 25.6719C158.422 25.0948 158.871 24.6041 159.418 24.2445L178.676 13.145L178.731 13.1156L178.761 13.0972C179.703 12.7238 181.206 13.5078 182.027 14.1066C181.509 13.8292 181.053 13.7181 180.362 14.1039L161.106 25.2071C160.551 25.5728 160.095 26.071 159.781 26.6567C159.467 27.2425 159.305 27.8972 159.308 28.5616L159.339 78.2853C159.336 78.542 159.399 78.7951 159.523 79.0201C159.642 79.2447 159.817 79.4346 160.032 79.5712C160.463 79.8307 160.976 79.9173 161.468 79.8137C159.788 80.5026 157.844 79.382 157.73 77.5284C157.713 77.4406 157.705 77.3514 157.705 77.262L157.646 27.5567C157.641 26.8993 157.802 26.2513 158.113 25.6719Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M157.128 32.5646C157.127 32.5556 157.127 32.5466 157.127 32.5376V31.7881C157.127 31.6001 157.214 31.4107 157.41 31.3284C157.588 31.2535 157.779 31.3016 157.926 31.3895C158.073 31.4758 158.197 31.5957 158.288 31.7392L158.288 31.7392L158.289 31.7398C158.38 31.8839 158.435 32.0478 158.449 32.2177C158.45 32.2251 158.45 32.2325 158.45 32.24V32.9877C158.45 33.1691 158.371 33.363 158.172 33.4477C157.992 33.524 157.801 33.4721 157.655 33.388L157.655 33.388L157.653 33.387C157.506 33.3009 157.382 33.1803 157.291 33.0357C157.201 32.8936 157.145 32.7322 157.128 32.5646Z"
        fill="#FFD6BC"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M157.128 37.033C157.127 37.0242 157.127 37.0152 157.127 37.0063V34.7614C157.127 34.574 157.214 34.3844 157.41 34.3025C157.589 34.2279 157.78 34.2772 157.928 34.3675C158.072 34.4535 158.195 34.572 158.286 34.7135L158.286 34.7135L158.287 34.7152C158.377 34.858 158.433 35.0197 158.45 35.1876C158.451 35.1968 158.452 35.206 158.452 35.2152V37.4582C158.452 37.6466 158.364 37.8357 158.168 37.9175C157.99 37.9917 157.8 37.9438 157.653 37.8573L157.653 37.8574L157.651 37.8563C157.506 37.7695 157.383 37.6498 157.292 37.5068C157.201 37.3638 157.145 37.2016 157.128 37.033Z"
        fill="#FFD6BC"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M157.128 40.9963C157.127 40.9874 157.127 40.9785 157.127 40.9696V38.7247C157.127 38.5372 157.214 38.3477 157.41 38.2658C157.589 38.1912 157.78 38.2405 157.928 38.3308C158.072 38.4168 158.195 38.5353 158.286 38.6768L158.286 38.6768L158.287 38.6785C158.377 38.8213 158.433 38.983 158.45 39.1509C158.451 39.1601 158.452 39.1693 158.452 39.1784V41.4215C158.452 41.6099 158.364 41.7989 158.168 41.8808C157.99 41.955 157.8 41.9071 157.653 41.8206L157.653 41.8206L157.651 41.8196C157.506 41.7327 157.383 41.613 157.292 41.4701C157.201 41.3271 157.145 41.1649 157.128 40.9963Z"
        fill="#FFD6BC"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M169.18 24.5074C166.725 25.9803 165.743 22.5434 163.78 23.5254L177.527 15.6697C175.809 16.6517 177.036 20.0885 175.563 21.0705C174.09 22.0525 171.635 23.0344 169.18 24.5074Z"
        fill="#FFD6BC"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        clipRule="evenodd"
        d="M174.377 19.4348C174.467 19.5933 174.411 19.7948 174.253 19.8849L168.898 22.9305C168.74 23.0206 168.538 22.9652 168.448 22.8068C168.358 22.6483 168.413 22.4468 168.572 22.3567L173.927 19.3111C174.085 19.221 174.287 19.2764 174.377 19.4348Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <circle
        cx="8.52967"
        cy="8.52967"
        fill="white"
        r="8.26067"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
        transform="matrix(0.86601 -0.500028 -3.18395e-05 1 163.758 42.9768)"
      />
      <path
        d="M169.953 50.4404C170.045 50.4886 170.191 50.4015 170.28 50.2448L174.791 42.3134C174.951 42.0326 175.211 41.8805 175.373 41.9731C175.536 42.0664 175.538 42.3723 175.377 42.6551L170.422 51.3659C170.265 51.6425 170.01 51.7948 169.847 51.7097L167.177 50.3134C167.011 50.2264 167.003 49.924 167.16 49.6391C167.317 49.3561 167.576 49.1976 167.742 49.284L169.953 50.4404Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M149.803 61.8721L149.803 54.1973L153.899 55.7795L149.803 61.8721Z"
        fill="#1D1D1B"
        stroke="#1D1D1B"
        strokeLinejoin="round"
        strokeWidth="0.538"
      />
      <path
        d="M151.156 57.2399L122.397 74.3024"
        stroke="#1D1D1B"
        strokeDasharray="3 3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.6"
      />
      <path
        d="M196.659 56.2412V44.5408L211.133 40.9239C211.052 44.0027 210.975 50.2624 210.975 51.447C210.975 52.6316 210.588 52.8913 210.395 53.0127L201.81 57.5035C201.072 57.9162 200.393 58.061 198.992 57.9769C197.592 57.8928 196.659 56.7753 196.659 56.2412Z"
        fill="#FFD6BC"
        stroke="#1D1D1B"
        strokeWidth="0.5"
      />
      <path
        d="M206.071 39.0853L197.474 43.5314C196.723 43.9164 196.057 44.7079 197.563 45.8988C198.859 46.9237 200.647 46.8887 201.557 46.6114L210.486 42.0163C210.974 41.7223 211.657 40.8389 210.486 39.6566C209.315 38.4743 207.055 38.7831 206.071 39.0853Z"
        fill="#FFEADD"
        stroke="#1D1D1B"
        strokeWidth="0.5"
      />
      <ellipse
        cx="200.647"
        cy="44.155"
        fill="#1D1D1B"
        rx="0.934135"
        ry="0.435325"
        stroke="#1D1D1B"
        strokeWidth="0.5"
      />
      <ellipse
        cx="200.656"
        cy="44.1909"
        rx="1.46922"
        ry="0.743681"
        stroke="#1D1D1B"
        strokeWidth="0.5"
      />
      <ellipse
        cx="207.534"
        cy="40.7691"
        rx="1.4608"
        ry="0.730399"
        stroke="#1D1D1B"
        strokeWidth="0.5"
      />
      <path
        d="M199.505 44.2686C199.667 44.5127 199.997 44.7258 200.606 44.7051C201.172 44.6858 201.501 44.5329 201.725 44.3738V37.7874C201.725 35.2104 203.574 34.715 204.499 34.741C205.766 34.741 206.381 35.9397 206.381 36.9993V40.9315C206.71 41.2428 207.987 41.532 208.582 40.9216C208.584 40.9192 208.586 40.9167 208.589 40.9143V36.3503C208.589 32.9899 205.837 32.1052 204.205 32.2663C199.504 32.7308 199.505 36.5076 199.505 37.7711L199.505 44.2686Z"
        fill="white"
        stroke="#1D1D1B"
        strokeWidth="0.5"
      />
    </svg>
  );
}
